/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pnav_MoreInputs */

const en_pnav_more = /** @type {(inputs: Pnav_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product actions`)
};

const de_pnav_more = /** @type {(inputs: Pnav_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produktaktionen`)
};

/**
* | output |
* | --- |
* | "Product actions" |
*
* @param {Pnav_MoreInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pnav_more = /** @type {((inputs?: Pnav_MoreInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pnav_MoreInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pnav_more(inputs)
	return en_pnav_more(inputs)
});